import { createTheme } from '@material-ui/core/styles';

export const createXDomeTheme = () => {
   return createTheme({
      props: {
         MuiButton: {
            disableElevation: true,
         },
      },
      typography: {
         fontFamily: 'Open Sans',
         body1: {
            fontSize: 12
         },
         button: {
            textTransform: 'none'
         },
         h1: {
            fontWeight: 600,
            fontSize: 40
         },
         h2: {
            fontWeight: 300,
            fontSize: 24
         },
         h3: {
            fontWeight: 300,
            fontSize: 20
         },
         h4: {
            fontWeight: 300,
            fontSize: 17
         },
         h5: {
            fontWeight: 300,
            fontSize: 13
         }
      },
      overrides: {
         MuiLink: {
				button: {
               color: "#2196f3",
				},
				underlineNone: {
					'&:hover': {
						color: '#2e9e9e'
					}
				}
			},
         MuiButton: {
         }
      },
      palette: {
         primary: {
            main: '#186ea8'
         },
         secondary: {
            main: '#2e9e9e'
         }
      }
   })
}